import axios from '../../../axios'



// 获取列表
export const list = (data) => {
  return axios({
    url: '/workorder/woDefect/list',
    method: 'post',
    data
  })
}

// 查看详情
export const view = (data) => {
  return axios({
    url: '/workorder/woDefect/view',
    method: 'post',
    data
  })
}

// 修改
export const edit = (data) => {
  return axios({
    url: '/workorder/woDefect/edit',
    method: 'post',
    data
  })
}

// 提交
export const save = (data) => {
  return axios({
    url: '/workorder/woDefect/save',
    method: 'post',
    data
  })
}

// 删除
export const singleDelete = (data) => {
  return axios({
    url: '/workorder/woDefect/delete',
    method: 'post',
    data
  })
}
// 开始执行
export const start = (data) => {
  return axios({
    url: '/workorder/woDefect/start',
    method: 'post',
    data
  })
}
// 执行
export const endExecute = (data) => {
  return axios({
    url: '/workorder/woDefect/endExecute',
    method: 'post',
    data
  })
}
// 获取该路段最新填报人
export const getLastReportPerson = (data) => {
  return axios({
    url: '/workorder/woDefect/getLastReportPerson',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/biz/workorder/woDefect.js